"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestSetting = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const TestSettingStyled = styled_components_1.default.div `
	&.header {
		display: flex;
		flex-direction: ${props => (props.$isMobile ? 'column' : 'row')};
		align-items: flex-end;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		gap: ${props => (props.$isMobile ? '12px' : '0')};

		.test-setting {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--h5-font-size, 16px);
			line-height: var(--h5-line-height, 24px);
			font-weight: var(--h5-font-weight, 700);
			position: relative;
			width: 100%;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}
`;
exports.TestSetting = react_1.default.memo(({ tableName, children }) => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    return (react_1.default.createElement(TestSettingStyled, { className: "header test-setting", "$isMobile": isMobile, "$isDesktop": isDesktop, "$isTablet": isTablet },
        !isMobile && react_1.default.createElement("div", { className: "test-setting" }, tableName),
        react_1.default.createElement("div", { className: "btn-container", style: { padding: 0, margin: 0 } }, children)));
});
